import { stringify } from "query-string"
import { dhFoods, dhFoodsMain } from "./api"

const endpoint = "/contract"

export const getAllContracts = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/all?${query}`)

  return response.data
}

export const getServer = async (contractId) => {
  const response = await dhFoods.get(`${endpoint}/${contractId}`)

  return response.data
}

export const activateService = async (contractId, status) => {
  const response = await dhFoods.post(`${endpoint}/activation/${contractId}?status=${status}`)

  return response.data
}

export const getServiceActivation = async contractId => {
  const response = await dhFoods.get(`${endpoint}/activation/${contractId}`)

  return response.data
}

export const editSecurityKeys = async (contractId, data) => {
  const response = await dhFoods.post(`${endpoint}/securitykeys/${contractId}`, data)

  return response.data
}

export const doesClientNameExist = async (clientname) => {
  const response = await dhFoods.get(`${endpoint}/clientname/checking/${clientname}`)

  return response.data
}

export const getContractStatsMain = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoodsMain.get(`${endpoint}/stats?${query}`)

  return response.data
}

export const addPremiumContract = async (data) => {
  const response = await dhFoods.post(`${endpoint}/add/premium`, data)

  return response.data
}

export const changeToPremiumContract = async (contractId, data) => {
  const response = await dhFoods.patch(`${endpoint}/change/premium/${contractId}`, data)

  return response.data
}

export const startBillingContractsJobHandler = async () => {
  const response = await dhFoodsMain.post(`${endpoint}/start/billing/job`)

  return response.data
}

export const getContractCustomDomain = async contractId => {
  const response =
    await dhFoods.get(`${endpoint}/${contractId}/custom-domain`)

  return response.data
}

export const setContractCustomDomain = async (contractId, domain) => {
  const response =
    await dhFoods.put(`${endpoint}/${contractId}/custom-domain`, { domain })

  return response.data
}

export const verifyContractCustomDomain = async contractId => {
  const response =
    await dhFoods.post(`${endpoint}/${contractId}/custom-domain/verify`)

  return response.data
}

export const forceVerifyContractCustomDomain = async contractId => {
  const response =
    await dhFoods.post(`${endpoint}/${contractId}/custom-domain/force-verify`)

  return response.data
}

export const removeContractCustomDomain = async contractId => {
  await dhFoods.delete(`${endpoint}/${contractId}/custom-domain`)
}

export const getContractPageDecorationTemplates = async contractId => {
  const response =
    await dhFoods.get(`${endpoint}/page-decoration-templates/${contractId}`)

  return response.data
}

export const setContractPageDecorationTemplates = async (contractId, data) => {
  const response =
    await dhFoods.put(`${endpoint}/page-decoration-templates/${contractId}`, data)

  return response.data
}
